import english from "./english.json";

export default {
  en: english,
};
